module.exports = __webpack_public_path__ + "img/tech-startup-bg-light.b5a6d4ab.svg";